import { render, staticRenderFns } from "./personalPoint.vue?vue&type=template&id=c000264e&scoped=true&"
import script from "./personalPoint.vue?vue&type=script&lang=ts&"
export * from "./personalPoint.vue?vue&type=script&lang=ts&"
import style0 from "./personalPoint.vue?vue&type=style&index=0&id=c000264e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c000264e",
  null
  
)

export default component.exports